import {useCallback, useState} from "react";
import {ModalTarget} from "@/modal/ModalHooks.ts";
import {useModalPreviewContent} from "@/modal/useModalPreviewContent.ts";

type PreviewState =
    | {mode: "follow"}
    | {mode: "closed"}
    | {mode: "preview"; target: ModalTarget};

export function useModalPreview(enabled: boolean) {
    const [state, setState] = useState<PreviewState>({mode: "follow"});
    const target = enabled && state.mode === "preview" ? state.target : undefined;
    const loaded = useModalPreviewContent(target);
    const show = useCallback((next: ModalTarget) => setState({mode: "preview", target: next}), []);
    const close = useCallback(() => setState({mode: "closed"}), []);

    return {
        followsPresentation: !enabled || state.mode === "follow",
        target,
        content: target ? loaded.content : undefined,
        loading: Boolean(target) && loaded.loading,
        error: target ? loaded.error : undefined,
        show,
        close,
    };
}
